interface Props {
  lat: number;
  lng: number;
  zoom?: number;
}

// Minimal embed via Yandex map widget iframe — works without an API key.
// If a key is provided we still embed the same widget; full ymaps3 wiring can be added later.
export function YandexMap({ lat, lng, zoom = 16 }: Props) {
  const url = `https://yandex.ru/map-widget/v1/?ll=${lng}%2C${lat}&z=${zoom}&pt=${lng},${lat},pm2rdm`;
  return (
    <div className="rounded-2xl overflow-hidden bg-surface aspect-[16/10]">
      <iframe
        title="map"
        src={url}
        loading="lazy"
        className="w-full h-full border-0"
        allow="geolocation"
      />
    </div>
  );
}
